module.exports = __webpack_public_path__ + "img/border-none.70b25d1c.svg";